import React from 'react';
import { Outlet } from 'react-router-dom';
import AuthorizationProvider from '../hooks/Authorize';
import Navbar from '../layouts/Navbar';

const AuthorizeRouter = () => {
    return (
        <AuthorizationProvider>
            <Navbar>
                <Outlet />
            </Navbar>
        </AuthorizationProvider>
    );
};

export default AuthorizeRouter;
